<template>
<v-container>
    <v-toolbar>
      <v-toolbar-title>Innovotes BETA</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container class="grey lighten-4" fluid>
      <v-subheader>Open Innovation para tu organización.</v-subheader>

      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="400">   

            <v-card-text class="text--primary">
              <h2>Bienvenido</h2>
              <v-subheader>¿En que organización quieres trabajar?</v-subheader>
            </v-card-text>

            <v-card-actions>
            
              <v-btn v-if="pid" :disabled="!shouldShowOrganization" v-on:click="goPID()" color="success">
                Ir a {{pid}}
              </v-btn>

              <v-btn v-if="!pid" v-on:click="goLogin()" color="success">
                Identificarme
              </v-btn>
              <v-row align="center" justify="end">
                <v-btn v-on:click="goDemo()" color="warning" text>
                  Ir a la DEMO
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="authenticated">
        <v-col>
          <v-card class="mx-auto" max-width="400">   

            <v-card-text class="text--primary">
              <div>O desconectate para acceder a otra organización.</div>
            </v-card-text>

            <v-card-actions>
              <v-btn v-on:click="logOut()" color="red" text>
                Desconectarme
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
<Footer></Footer>
</v-container>
</template>

<script>
import router from '@/router/index.js'
import Footer from '@/components/Footer.vue'
import SDK from '@/services/api.service.js'
//import authentication from '@/services/auth.service.js'

export default {
  name: 'Index',
  components: {
    Footer
  },
  data: () => {
    return {
      pid: null,
      authenticated: false,
      shouldShowOrganization: false
    }
  },
  created() {
    this.authenticated = this.$AuthService.isAuthenticated();
    if (this.$AuthService.isAuthenticated()) {
      this.updatePid();
      
      let sdk = new SDK({ pid: this.pid });
      sdk.getChallenges().then((challenges) => {
        this.shouldShowOrganization = challenges && challenges.length > 0;
      });
    }
    
  },
  watch: {
    '$route': 'Index'
  },
  methods: {
    async updatePid() {
      this.authenticated = this.$AuthService.isAuthenticated();
      let up = this.$AuthService.getUserProfile();
      if (up) {
        let { unique_name } = up;
        if (unique_name) {
          this.pid = unique_name.split('@')[1];
        } else this.pid = null;
      }
    },
    async goDemo() {
      router.push({ path: `/demo` });
    },
    async goPID() {
      let pid = this.pid;
      router.push({ path: `/${pid}` });
    },     
    async goLogin() {
      this.$AuthService.signIn();
    },     
    logOut() {
      this.$AuthService.signOut();
    }
  }
}

</script>
